export const HealthStatus = {
  OK: 'ok',
  ALERT: 'alert',
  UNKNOWN: 'unknown'
} as const;
export type HealthStatusType = (typeof HealthStatus)[keyof typeof HealthStatus];

export type HealthCheckRow = Record<string, unknown>;

export interface HealthCheckResult {
  key: string;
  category: string;
  title: string;
  guidance: string;
  status: HealthStatusType;
  rowCount: number;
  rows: HealthCheckRow[];
  lastRunAt: string | null;
}

export const STATUS_LABELS: Record<HealthStatusType, string> = {
  [HealthStatus.OK]: 'OK',
  [HealthStatus.ALERT]: 'Needs Attention',
  [HealthStatus.UNKNOWN]: 'Not Yet Run'
};
